/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_User_Name_LabelInputs */

const es_co2_signup_user_name_label = /** @type {(inputs: Signup_User_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre`)
};

/**

* @param {Signup_User_Name_LabelInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const signup_user_name_label = /** @type {((inputs?: Signup_User_Name_LabelInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_User_Name_LabelInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_signup_user_name_label(inputs)
});